import { useMemo } from "react";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";
import { getFeature } from "../../utils/features";

interface FitAssistExperimentParams {
  fitAssistEligible?: boolean;
}

interface FitAssistExperimentResult {
  isSuppressed: boolean;
  isEvaluationComplete: boolean;
}

const getSuppressionState = ({
  areFeaturesReady,
  fitAssistEligible,
}: {
  areFeaturesReady: boolean;
  fitAssistEligible?: boolean;
}): FitAssistExperimentResult => {
  if (!areFeaturesReady) {
    return {
      isSuppressed: false,
      isEvaluationComplete: false,
    };
  }

  if (!fitAssistEligible) {
    return {
      isSuppressed: false,
      isEvaluationComplete: true,
    };
  }

  const { isEnabled, getVariables } = getFeature("web-pdp-fit-assist");

  const variables = getVariables() as { bucket?: string } | null;

  return {
    isSuppressed: isEnabled() && variables?.bucket === "v1",
    isEvaluationComplete: true,
  };
};

export default function useFitAssistExperiment({
  fitAssistEligible,
}: FitAssistExperimentParams = {}): FitAssistExperimentResult {
  const { areFeaturesReady } = useFeaturesReady() as {
    areFeaturesReady: boolean;
  };

  return useMemo(
    () => getSuppressionState({ areFeaturesReady, fitAssistEligible }),
    [areFeaturesReady, fitAssistEligible]
  );
}
